import { isEmpty, values } from 'lodash';

export function getQuizSolved(state, getters) {
  return !isEmpty(getters.getQuizResult);
}

export function getQuizResult(state, getters) {
  if (isEmpty(getters.getCard) || isEmpty(getters.getPage)) {
    return {};
  }

  if (!getters.isAssignmentSubmitted &&
      !getters.getCard.due_date_passed &&
      !getters.isForceResult) {
    return {};
  }

  if (!isEmpty(getters.getPage.submitted_answer)) {
    return getters.getPage.submitted_answer;
  }

  if (!isEmpty(getters.getPage.submitted_answers)) {
    return getters.getPage.submitted_answers[0];
  }

  return { };
}

export function getQuizResults(state, getters) {
  return state.quizResults[getters.getCard.id] || {};
}

export function getCardQuizResults(state, getters) {
  const quizResults = values(state.quizResults);

  return quizResults.filter(quizResult => quizResult.card_id === getters.getCardId);
}

export function getQuizzesCount(state, getters) {
  const pages = values(getters.getPages);

  return pages.filter(page => page.position < getters.getPage.position && page.is_quiz).length;
}

export function getContentsCount(state, getters) {
  if (!isEmpty(getters.getCoinPages)) {
    return getters.getCoinContentsCount;
  }

  const pages = values(getters.getPages);

  return pages.filter(page => (
    page.position < getters.getPage.position && !page.is_quiz
  )).length;
}

export function getCorrectQuizzesCount(state, getters) {
  const cardQuizResults = values(getters.getQuizResults);

  return cardQuizResults.filter(quizResult => quizResult.is_correct).length;
}

export function getMaxCombo(state, getters) {
  const cardQuizResults = values(getters.getQuizResults);

  let maxCombo = 0;
  let tempMaxCombo = 0;

  cardQuizResults.forEach((quizResult) => {
    if (quizResult.is_correct) {
      tempMaxCombo += 1;
    } else {
      if (tempMaxCombo > maxCombo) {
        maxCombo = tempMaxCombo;
      }

      tempMaxCombo = 0;
    }
  });

  maxCombo = tempMaxCombo > maxCombo ? tempMaxCombo : maxCombo;

  return maxCombo;
}

export function getStartCombo(state, getters) {
  const cardQuizResults = values(getters.getQuizResults);

  let startCombo = 0;

  cardQuizResults.some((quizResult) => {
    if (quizResult.is_correct) {
      startCombo += 1;
    }

    return !quizResult.is_correct;
  });

  return startCombo;
}

export function getLastCombo(state, getters) {
  const cardQuizResults = values(getters.getQuizResults).reverse();

  let lastCombo = 0;

  cardQuizResults.some((quizResult) => {
    if (quizResult.is_correct) {
      lastCombo += 1;
    }

    return !quizResult.is_correct;
  });

  return lastCombo;
}

export function getSubmittedAnswer(state, getters) {
  if (!isEmpty(getters.getPage.submitted_answer)) {
    return getters.getPage.submitted_answer;
  }

  if (!isEmpty(getters.getPage.submitted_answers)) {
    return getters.getPage.submitted_answers[0];
  }

  return {};
}

export function getSavedQuizOptions(state, getters) {
  if (!isEmpty(getters.getPreselectedOption)) {
    return getters.getPreselectedOption;
  }

  if (!isEmpty(getters.getSubmittedAnswer)) {
    return {
      id: getters.getSubmittedAnswer.answer_id,
      ...getters.getSubmittedAnswer,
    };
  }

  return {};
}

export function getSavedQuizValue(state, getters) {
  if (!isEmpty(getters.getPreEnteredValue)) {
    return getters.getPreEnteredValue;
  }

  if (!isEmpty(getters.getSubmittedAnswer)) {
    return getters.getSubmittedAnswer.value;
  }

  return '';
}

